import './TimeseriesSelectionAreaTooltip.css';
export var disabledActions = '_rayty80-2-0-1';